export default {
  'algebra-1': 63150
};
